import { capitalize } from "helpers/Helpers";
import "./FilterTags.scss";

import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";

interface IFilterTagsProps<T extends Record<string, unknown>> {
  filterState: T;
  filterKeys: (keyof T)[];
  onClearFilter: (key: keyof T) => void;
}

export default function FilterTags<T extends Record<string, unknown>>({
  filterState,
  filterKeys,
  onClearFilter,
}: IFilterTagsProps<T>) {
  return (
    <div className="pt-2 flex flex-row gap-2">
      {filterKeys.map(key => {
        const selectedFilterIdsByKey = filterState[key] as Array<number | string>;
        const MAX_VISIBLE = 2;
        const visibleIds = selectedFilterIdsByKey.slice(0, MAX_VISIBLE);
        const remainingCount = selectedFilterIdsByKey.length - visibleIds.length;

        if (selectedFilterIdsByKey.length === 0) {
          return null;
        }
        return (
          <div key={key as string} className="filter-tag-container flex flex-row">
            <p>{capitalize(key as string)}:</p>
            {visibleIds.join(", ")}
            {remainingCount > 0 && <div>{`+${remainingCount}`}</div>}{" "}
            <div className="tag-select_tag_display_remove_icon" onClick={() => onClearFilter(key as string)}>
              <FontAwesomeIcon icon={faXmark} />{" "}
            </div>
          </div>
        );
      })}
    </div>
  );
}
